import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import UserResource from '../../resources/user'
import toastMixin from '../../mixins/toast'

import userGridColumns from './userGridColumns'

export default Vue.extend({
    data() {
        return {
            userColumnDefs: [],
            userRowData: [],
        }
    },
    props: ['userId'],
    mixins: [toastMixin],
    methods: {
        async fetchUserInfo(userId) {
            try {
                const userResource = await UserResource.detail(userId)
                this.userRowData = [userResource]
            } catch (error) {
                this.createToast('b-toaster-top-center', 'danger', true, 'Network Error', 'Error getting Users')
            }
        },
    },
    components: {
        AgGridVue,
    },
    watch: {
        userId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchUserInfo(newVal)
            }
        },
    },
    async mounted() {
        if (this.userId) {
            this.fetchUserInfo(this.userId)
        } else {
            const userResource = await UserResource.list()
            this.userRowData = userResource.resources
        }
        this.userColumnDefs = userGridColumns
    },
})
